export default __webpack_public_path__ + "static/setup-services-bbbcfb01a22afd28181c85d8657c36b3.gif";